var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFav = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10 4.28 1.453 4.47h4.7l-3.803 2.763 1.452 4.47-3.803-2.763-3.803 2.763 1.452-4.47L3.845 8.75h4.7l1.452-4.47zm0-4.045L7.639 7.5H0l6.18 4.49-2.361 7.265 6.18-4.49 6.18 4.49-2.361-7.265 6.18-4.49h-7.639L9.998.235z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFav);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/fav.svg";